export default {
  presenter: 'ansorgova',
  title: 'Jak začít dokumentovat',
  subtitle: 'mírně pokročilí',
  text: `
Proč psát dokumentaci a pro koho; trocha teorie - současné přístupy k tvorbě, správě a dodávání
obsahu; open-source nástroje; praktická ukázka jak začít
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/ansorgova-dokumentacia.js